export default "__VITE_ASSET__GiSWUGKe__"